import { ComponentValues } from './component-values'

export class CcComponentValues extends ComponentValues {
  key
  constructor(values, key) {
    super(values)
    this.key = key
  }
}
